import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-picture-upload-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfPictureUploadIconProps extends SvgIconProps {}

/**
 * Component used to display Picture/Photo Upload Icon
 * @param props - CcfPictureUploadIconProps
 * @returns
 * @example
 */
export function CcfPictureUploadIcon(props: CcfPictureUploadIconProps) {
  return (
    <SvgIcon width="57" height="50" viewBox="0 0 57 50" fill="none" {...props}>
      <path
        d="M5.57157 50C4.15729 50 2.94614 49.51 1.93814 48.53C0.930144 47.55 0.427001 46.3733 0.428715 45V15C0.428715 13.625 0.932715 12.4475 1.94072 11.4675C2.94872 10.4875 4.159 9.99833 5.57157 10H13.6716L18.4287 5H33.8573V15H41.5716V22.5H51.8573V45C51.8573 46.375 51.3533 47.5525 50.3453 48.5325C49.3373 49.5125 48.127 50.0017 46.7144 50H5.57157ZM26.143 41.25C29.3573 41.25 32.0899 40.1558 34.3407 37.9675C36.5916 35.7792 37.7161 33.1233 37.7144 30C37.7144 26.875 36.589 24.2183 34.3381 22.03C32.0873 19.8417 29.3556 18.7483 26.143 18.75C22.9287 18.75 20.1961 19.8442 17.9453 22.0325C15.6944 24.2208 14.5699 26.8767 14.5716 30C14.5716 33.125 15.697 35.7817 17.9479 37.97C20.1987 40.1583 22.9304 41.2517 26.143 41.25ZM26.143 36.25C24.343 36.25 22.8216 35.6458 21.5787 34.4375C20.3359 33.2292 19.7144 31.75 19.7144 30C19.7144 28.25 20.3359 26.7708 21.5787 25.5625C22.8216 24.3542 24.343 23.75 26.143 23.75C27.943 23.75 29.4644 24.3542 30.7073 25.5625C31.9501 26.7708 32.5716 28.25 32.5716 30C32.5716 31.75 31.9501 33.2292 30.7073 34.4375C29.4644 35.6458 27.943 36.25 26.143 36.25ZM46.7144 15V10H41.5716V5H46.7144V0H51.8573V5H57.0001V10H51.8573V15H46.7144Z"
        fill="#3F5C69"
      />
    </SvgIcon>
  );
}

export default CcfPictureUploadIcon;
